import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./feature/userSlice";
import principalReducer from "./feature/principalSlice";
import rcsTempReducer from "./feature/RcsTemplateSlice";
import { userApi } from "./services/userApi";
import { principleApi } from "./services/principleApi";
import { headerApi } from "./services/headerApi ";
import { templateApi } from "./services/templateApi";
import { commonApi } from "./services/commonApi";
import templateReducer from "./feature/templateSlice";
import { blacklistApi } from "./services/blacklistApi";
import commonReducer from "./feature/commonSlice";
import { customerApi } from "./services/customerApi";
import { setupListeners } from "@reduxjs/toolkit/query";
import { smsApi } from "./services/smsApi";
import { resellerApi } from "./services/resellerApi";
import { reportApi } from "./services/reportApi";
import { transactionApi } from "./services/transactionApi";
import { clickerApi } from "./services/clickerApi";
import { shortLinkApi } from "./services/shortLinkApi";
import { rcsTemplateApi } from "./services/rcstemplateApi";
import { createDbapi } from "./services/createDbApi";
import { trueCallerApi } from "./services/trucallerApi";
import { missedCallApi } from "./services/missedCallApi";
import { whatsApi } from "./services/whatsappApi";
import { rcsBotsApi } from "./services/rcsBotsApi";
import { flowApi } from "./services/flowApi";
import { categoryApi } from "./services/categoryApi";
import { emailApi } from "./services/emailApi";

export const store = configureStore({
  reducer: {
    user: userReducer,
    principal: principalReducer,
    template: templateReducer,
    common: commonReducer,
    rcs: rcsTempReducer,
    [userApi.reducerPath]: userApi.reducer,
    [principleApi.reducerPath]: principleApi.reducer,
    [headerApi.reducerPath]: headerApi.reducer,
    [templateApi.reducerPath]: templateApi.reducer,
    [blacklistApi.reducerPath]: blacklistApi.reducer,
    [commonApi.reducerPath]: commonApi.reducer,
    [customerApi.reducerPath]: customerApi.reducer,
    [smsApi.reducerPath]: smsApi.reducer,
    [resellerApi.reducerPath]: resellerApi.reducer,
    [reportApi.reducerPath]: reportApi.reducer,
    [transactionApi.reducerPath]: transactionApi.reducer,
    [clickerApi.reducerPath]: clickerApi.reducer,
    [shortLinkApi.reducerPath]: shortLinkApi.reducer,
    [rcsTemplateApi.reducerPath]: rcsTemplateApi.reducer,
    [createDbapi.reducerPath]: createDbapi.reducer,
    [trueCallerApi.reducerPath]: trueCallerApi.reducer,
    [missedCallApi.reducerPath]: missedCallApi.reducer,
    [whatsApi.reducerPath]: whatsApi.reducer,
    [rcsBotsApi.reducerPath]: rcsBotsApi.reducer,
    [flowApi.reducerPath]: flowApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [emailApi.reducerPath]: emailApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([
      userApi.middleware,
      principleApi.middleware,
      headerApi.middleware,
      templateApi.middleware,
      blacklistApi.middleware,
      commonApi.middleware,
      customerApi.middleware,
      smsApi.middleware,
      resellerApi.middleware,
      reportApi.middleware,
      transactionApi.middleware,
      clickerApi.middleware,
      shortLinkApi.middleware,
      rcsTemplateApi.middleware,
      createDbapi.middleware,
      trueCallerApi.middleware,
      missedCallApi.middleware,
      whatsApi.middleware,
      rcsBotsApi.middleware,
      flowApi.middleware,
      categoryApi.middleware,
      emailApi.middleware,
    ]),
});

setupListeners(store.dispatch);
